// extracted by mini-css-extract-plugin
export default {"row":"lqhI","row-head":"AgyJ","rowHead":"AgyJ","panel-style":"Nu6Z","panelStyle":"Nu6Z","row-body":"jAgj","rowBody":"jAgj","row-footer":"tSVl","rowFooter":"tSVl","clickable":"UIzh"};